import { render } from "./OrderPaymentEditPage.vue?vue&type=template&id=155b8f5c"
import script from "./OrderPaymentEditPage.vue?vue&type=script&lang=js"
export * from "./OrderPaymentEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__